import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="native-settings"
export default class extends Controller {
  openNotificationSettings(event) {
    event.preventDefault();

    // Check if our custom Android Bridge exists
    if (window.AndroidSettingsBridge) {
      window.AndroidSettingsBridge.openAppNotificationSettings();
    } else {
      console.warn("Android Settings Bridge is not available in this context.");
    }
  }
}
